export function resolveApiBaseURL(origin, override) {
  const customBase = String(override || '').trim()
  if (customBase) return withTrailingSlash(customBase)

  const currentOrigin = origin || browserOrigin() || ''
  return withTrailingSlash(`${String(currentOrigin).replace(/\/+$/, '')}/a`)
}

export function resolveH5ApkDownloadUrl(sanitizeUrl) {
  const normalizeUrl =
    typeof sanitizeUrl === 'function'
      ? sanitizeUrl
      : value => String(value == null ? '' : value).trim()
  const envUrl =
    typeof process !== 'undefined' && process.env
      ? process.env.VUE_APP_H5_APK_DOWNLOAD_URL
      : ''
  return [safeRuntimeValue('__H5_APK_DOWNLOAD_URL__'), envUrl]
    .map(value => normalizeUrl(value))
    .find(url => /^https:\/\//i.test(url) && /\.apk(?:[?#]|$)/i.test(url)) || ''
}

// 资产 CDN 主机解析 —— 迁移到自有 CDN 只改 env / 部署时注入,无需改代码。
// 优先级:运行时 window.__CDN_BASE__(可不发版,部署期注入) > 构建期 VUE_APP_CDN_BASE > 默认当前主机。
// 默认保留 https://file.kk.game,确保未配置时行为与现状完全一致;
// 切自有 CDN: 构建配 VUE_APP_CDN_BASE=https://file.vukavi.com (资产需先镜像齐全)。
export function resolveCdnBase() {
  const envBase =
    typeof process !== 'undefined' && process.env
      ? process.env.VUE_APP_CDN_BASE
      : ''
  const base = String(safeRuntimeValue('__CDN_BASE__') || envBase || 'https://file.kk.game').trim()
  return base.replace(/\/+$/, '')
}

// 拼 CDN 资产绝对地址;已是绝对地址/data URI 原样返回。
export function cdnUrl(path) {
  const p = String(path == null ? '' : path).trim()
  if (!p) return resolveCdnBase()
  if (/^(https?:)?\/\//i.test(p) || /^data:/i.test(p)) return p
  return `${resolveCdnBase()}/${p.replace(/^\/+/, '')}`
}

export function safeRuntimeValue(key) {
  try {
    const win = browserWindow()
    return win && key ? win[key] : ''
  } catch (e) {
    return ''
  }
}

function browserOrigin() {
  try {
    const win = browserWindow()
    const location = win && win.location
    const origin = location && location.origin
    return origin ? origin : ''
  } catch (e) {
    return ''
  }
}

function browserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

function withTrailingSlash(value) {
  return value.endsWith('/') ? value : `${value}/`
}
